import { Link } from "react-router-dom";

import { useAutoTradingTimer } from "@/hooks/useAutoTradingTimer";

import { AutoTradingControlButton } from "@/components/AutoTradingControlButton";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/Icon";
import { Logo } from "@/components/ui/Logo";
import { ROUTES } from "@/constants/routes";

interface HeaderProps {
  /** Right side variant */
  variant?: "dashboard" | "profile";
  /** User name for dashboard variant */
  userName?: string;
  /** Is user an admin */
  isAdmin?: boolean;
}

export const Header = ({ variant = "dashboard", userName, isAdmin }: HeaderProps) => {
  const timer = useAutoTradingTimer();

  return (
    <header className="glass-blur sticky top-0 z-50 flex items-center justify-between bg-neutral-950/2 p-6">
      {/* Left side: Logo + Shield + Admin */}
      <div className="flex items-center gap-4">
        <Link to={ROUTES.dashboard}>
          <Logo
            showText={false}
            className="md:hidden"
          />
          <Logo className="hidden md:flex" />
        </Link>
        <Link
          to={ROUTES.protect}
          className="outline-none"
        >
          <Button
            variant="neutral"
            buttonType="icon"
            size="sm"
            icon={<Icon name="shield" />}
          />
        </Link>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-2">
        {/* Timer and bot control button */}
        {timer && (
          <div className="flex items-center gap-2">
            <span className="fs-200 text-neutral-200/50">{timer}</span>
            <AutoTradingControlButton size="md" />
          </div>
        )}

        {/* Admin panel link */}
        {isAdmin && (
          <Link
            to={ROUTES.admin.root}
            className="outline-none"
          >
            <Button
              variant="neutral"
              buttonType="icon"
              size="md"
              className="md:hidden"
              icon={<Icon name="admin" />}
            />
            <Button
              variant="neutral"
              size="md"
              className="hidden md:flex"
              icon={<Icon name="admin" />}
            >
              Админ
            </Button>
          </Link>
        )}

        {/* Variant-specific right side */}
        {variant === "dashboard" ? (
          <Link
            to={ROUTES.profile}
            className="outline-none"
          >
            {/* Mobile: icon with larger padding */}
            <Button
              variant="neutral"
              buttonType="icon"
              size="md"
              className="md:hidden"
              icon={<Icon name="user" />}
            />
            {/* Desktop: icon + name */}
            <Button
              variant="neutral"
              size="md"
              className="hidden md:flex"
              icon={<Icon name="user" />}
            >
              {userName}
            </Button>
          </Link>
        ) : (
          <Link
            to={ROUTES.dashboard}
            className="outline-none"
          >
            {/* Mobile: icon with larger padding */}
            <Button
              variant="neutral"
              buttonType="icon"
              size="md"
              className="md:hidden"
              icon={<Icon name="angle-double-left" />}
            />
            {/* Desktop: icon + text */}
            <Button
              variant="neutral"
              size="md"
              className="hidden md:flex"
              icon={<Icon name="angle-double-left" />}
            >
              Вернуться к боту
            </Button>
          </Link>
        )}
      </div>
    </header>
  );
};
